export function getDisclaimerMessages(dataSourceType: string) {
    if (dataSourceType === "field_service_reports") {
        // TODO(AI): Update message
        return ["For internal use only. Do not distribute."];
    }
    return [];
}
